/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getApiEmployeesQueryParamsSchema = z.object({
  Filters: z.string().optional(),
  SortOrder: z.string().optional(),
  PageNumber: z.coerce.number().int(),
  PageSize: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getApiEmployees200Schema = z.object({
  items: z.array(
    z.object({
      id: z.coerce.number().int(),
      lastName: z.coerce.string().optional(),
      firstName: z.coerce.string().optional(),
      email: z.coerce.string().nullable().nullish(),
      phoneNumber: z.coerce.string().nullable().nullish(),
      username: z.coerce.string().optional(),
      timesheetDaysForward: z.coerce.number().int().nullable().nullish(),
      timesheetDaysBackward: z.coerce.number().int().nullable().nullish(),
      registrationNumber: z.coerce.string().nullable().nullish(),
      enabled: z.boolean().optional(),
      hoursPerDay: z.coerce.number().int().nullable().nullish(),
      employeeType: z
        .enum([
          'dipendente',
          'cliente',
          'amministratore',
          'utenteEvoluto',
          'consulente',
        ])
        .optional(),
      hasCv: z.boolean().optional(),
      hasCvPreview: z.boolean().optional(),
      cvUpdateRequested: z.boolean().optional(),
      cvLastUpdatedAt: z
        .string()
        .datetime({ local: true })
        .nullable()
        .nullish(),
    }),
  ),
  pageNumber: z.coerce.number().int(),
  totalPages: z.coerce.number().int().optional(),
  pageSize: z.coerce.number().int(),
  currentPageSize: z.coerce.number().int().optional(),
  currentStartIndex: z.coerce.number().int().optional(),
  currentEndIndex: z.coerce.number().int().optional(),
  totalCount: z.coerce.number().int().optional(),
  hasPrevious: z.boolean().optional(),
  hasNext: z.boolean().optional(),
  nextPageNumber: z.coerce.number().int().nullable().nullish(),
});

export const getApiEmployeesQueryResponseSchema = z.lazy(
  () => getApiEmployees200Schema,
);
